import { Component, OnInit } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, FormControl, UntypedFormGroup, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { AppConfigurationService, AppSettings } from "../shared/services/app-configuration.service";
import { RegistrationService } from "./registration.service";
import { MyErrorStateMatcher } from "../shared/handler/form-error-functions";
import { TranslateService } from '@ngx-translate/core';
import { map } from "rxjs";

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.css'],
    standalone: false
})
export class RegistrationComponent implements OnInit {
  email: string = '';
  password: string = '';
  confirmPassword: string = '';
  code: string;
  url: string;
  registrationForm: UntypedFormGroup;
  registrationError: string = '';
  userExists: boolean;
  registrationValid: boolean;
  tenantId: string;
  loading: boolean;
  submitting = false;
  logoUrl: string;
  tenantName: string;
  tenantLogo: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RegistrationService,
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private appConfigurationService: AppConfigurationService) {

  }
  ngOnInit(): void {
    //send service call to API to update registration
    this.code = this.route.snapshot.queryParams['code'];
    this.password = '';
    this.registrationForm = this.fb.group({
      password: [{ value: this.password?.trim() ?? '', disabled: false }, [Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"), Validators.required]],
      confirmPassword: [{ value: this.confirmPassword?.trim() ?? '', disabled: false }, Validators.required],
      firstName: [{value: "", disabled: false}, Validators.required],
      lastName: [{value: "", disabled: false}, Validators.required],
      phoneNumber: [{value: "", disabled: false}]
    });
    this.tenantId = this.route.snapshot.params.tenantId;
    this.loading = true;

    this.appConfigurationService.settings$
    .pipe(
      map((settings: AppSettings) => {
        this.logoUrl = `${settings.contentDeliveryNetworkUrl}/logo-full.png`;
      })
    ).subscribe();
    
    this.service.get(this.code, this.tenantId)
    .pipe(
      map((registrationResponse: RegistrationResponse) => {
        this.loading = false;
        this.userExists = registrationResponse.userExists;
        this.registrationValid = registrationResponse.valid;
        this.tenantName = registrationResponse.tenantName;
        this.tenantLogo = `${registrationResponse.tenantLogo}`;
        if(!this.registrationValid){
          this.registrationError = this.translate.instant('@registrationExpiredMessage');
        }
      }))
      .subscribe();
  }
  submit() {
    if (this.submitting) {
      return;
    }
    const pw = this.registrationForm.get('password').value;
    const cpw = this.registrationForm.get('confirmPassword').value;
    if (!this.registrationForm.invalid) {
      const registration = {
        password: pw,
        registrationCode: this.code,
        firstName: this.registrationForm.get('firstName').value,
        lastName: this.registrationForm.get('lastName').value,
        phoneNumber: this.registrationForm.get('phoneNumber').value
      };
      this.submitting = true;
      this.registrationError = '';
      this.service.createNewUser(registration, this.tenantId).subscribe(res => {
        this.submitting = false;
        this.router.navigate(['']);
      },
      error => {
        this.submitting = false;
        this.registrationError = this.translate.instant('@registrationExpiredMessage');
      });
    }
  }
  submitExisting(){
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    this.registrationError = '';
    this.service.createExistingUser(this.code, this.tenantId).subscribe(res => {
        this.submitting = false;
        this.router.navigate(['']);
    },
    error => {
        this.submitting = false;
        this.registrationError = this.translate.instant('@registrationExpiredMessage');
    });
  }
  checkPasswords(){
      let pass = this.registrationForm.get('password').value;
      let confirmPassInput = this.registrationForm.get('confirmPassword');
      confirmPassInput.setErrors({ notSame: true });
      let confirmPass = confirmPassInput?.value
      if(pass === confirmPass) 
      {
        confirmPassInput.setErrors(null);
      }
  }

}
export class RegistrationResponse {
  valid: boolean;
  userExists: boolean;
  tenantName: string;
  tenantLogo: string;
}

